import { USER_FRAGMENT } from 'data/fragments/user.fragments';
import gql from 'graphql-tag';

export const GET_USER = gql`
    query GET_USER {
        user {
            ...UserFragment
        }
    }
    ${USER_FRAGMENT}
`;

export const GET_APP_USERS = gql`
    query GET_APP_USERS {
        appUsers {
            _id
            username
            emails {
                address
                verified
            }
            lastSeenAt
            roles
            profile {
                organizationId
                state
            }
            organization {
                _id
                name
            }
        }
    }
`;

export const GET_USERS_OF_ORGANIZATION = gql`
    query GET_USERS_OF_ORGANIZATION {
        usersOfOrganization {
            _id
            username
            emails {
                address
                verified
            }
            createdAt
            updatedAt
            lastSeenAt
            profile {
                firstname
                lastname
                organizationId
                phone
                jobTitle
            }
            roles
            userGroupIds
            wallet {
                organizationCard {
                    _id
                    state
                }
            }
        }
    }
`;
